import PropTypes from "prop-types";
import ColorPalette from "./ColorPalette";

const Layout = (props) => {
  return (
    <main className="site-main container">
      <ColorPalette {...props} />
    </main>
  );
};

Layout.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default Layout;
